// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__YsmEv","content":"styles_content__3R3bL"};